exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".required-indicator {\n  color: red;\n  white-space: pre; }\n\n.scrollable {\n  overflow-y: auto; }\n\n.error-icon {\n  color: red; }\n\n.legend-override {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: 700;\n  border: none;\n  font-size: 16px; }\n\n.label-override {\n  font-size: 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/common.scss
// module id = 687
// module chunks = 0